<template lang="pug">
.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-3
	.card.panel-success
		.card-header.text-white(:class="clase") {{ titulo }} ({{listadoProcesado.length}} tareas)
		table.table.table-striped.mb-0
			tbody
				tr(
					:style="(tareaVieja(tarea)) ? {'opacity': 0.5} : {}" :class="(tarea.publica) ? 'bg-dark text-white' : ''" style="cursor:pointer;" 
					v-for="tarea in listadoProcesado" :key="tarea.ID_tarea" 
					@click="seleccionar(tarea.ID_tarea, tarea.tareaTitulo)")
					td(style="width:3px;position:relative;" v-if="tarea.fase === 'pteProduccion'")
						div.bg-info(style="position:absolute;display:block;bottom:0;left:0;width:2px;transition:all 300ms ease-in-out;" :style="{height: tarea.porcentaje_grabado + '%'}")
					td(v-if="!esTareaValida(tarea) || tarea.externa || tarea.vocesExternas || tareaVieja(tarea)" style="width:30px;text-align:center")
						span(v-if="!esTareaValida(tarea)" class="fa fa-ban text-danger" style="font-size:2em;" title="Faltan datos por completar")
						span(v-if="esTareaValida(tarea) && tarea.externa" class="fa fa-gift text-warning" style="font-size:2em;" title="Producción externa")
						span.fa.fa-globe.text-danger(style="font-size: 2em;" title="Locutores externos seleccionados" v-if="tarea.vocesExternas")
						span.fa.fa-trash.text-dark(style="font-size:2em" title="Esta tarea se pasa más de 1 mes de la fecha de creación y será eliminada próximamente" v-if="tareaVieja(tarea)")
					td(:colspan="(esTareaValida(tarea) && !tarea.externa && !tarea.vocesExternas && !tareaVieja(tarea)) ? 2 : 1")
						b {{ tarea.anuncianteNombre }}
						br
						| {{ tarea.ordenTitulo }}
						br
						span(:class="(tarea.publica) ? 'text-light' : 'text-muted'") {{ tarea.tareaTitulo }}
						br
						span(:class="(tarea.publica) ? 'text-light' : 'text-muted'" style="font-size:0.8em;") Fecha de compromiso: {{ tarea.fecha_inicio / 1000 | moment('DD-MM-YYYY')}}
						div.bg-warning.p-1(v-if="tarea.express" style="border-radius: 3px;")
							b
								span.fa.fa-star.mr-2
								|Tarea express
					td(style="width:10px;font-size:1.2em;")
						span.fa.fa-volume-up(v-if="tarea.tipo === 'cuna'")
						br
						span.fa.fa-paint-brush(v-if="tarea.tipo === 'diseno'")
					td(style="text-align:center;width:50px;")
						img.rounded-circle(:src="tarea.agenteAvatar" width="50" :title="tarea.agenteNombre")
						span.badge.badge-danger.mt-2(v-if="tarea.numVersiones > 1" :title="tarea.numVersiones + ' versiones'")
							| {{tarea.numVersiones}} versiones
			div.p-3.text-center(v-if="listado.length === 0")
				span.fa.fa-smile-o.text-muted(style="font-size:6em;")
				h4.m-0.p-0.text-muted No hay tareas
</template>


<script>
import { mapGetters } from 'vuex'

export default {
	name: 'fase-tarea',
	props: ['titulo', 'listado', 'clase'],
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		}),
		listadoProcesado () {
			const arr = []

			for (let i = 0; i < this.listado.length; i++) {
				if (this.listado[i].fase !== 'cancelada' && (this.esTareaValida(this.listado[i]) || this.listado[i].agente_ID === this.usuario.ID)) {
					arr.push(this.listado[i])
				}
			}

			return arr
		}
	},
	methods: {
		seleccionar (idTarea, titulo) {
			this.$router.push('/main/produccion/tarea/' + idTarea)
			// this.$emit('abrir', {ID_tarea: idTarea, nombre: titulo})
		},

		tareaVieja (tarea) {
			if (!tarea.fecha_creacion_unix) {
				return false
			}

			const ahora = Math.floor(new Date().getTime() / 1000)

			return (ahora - tarea.fecha_creacion_unix > 2678400)
		},

		esTareaValida (tarea) {
			if (tarea.fase === 'finalizada') {
				return true
			}
			return (tarea.duracion && tarea.fecha_inicio && tarea.fecha_fin)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/fase-tareas-new.vue